import { useState, useCallback } from 'react';
import { supabase } from '@/lib/supabase/client';

export interface ComponentOperation {
  id: string;
  routing_id: string;
  component_id: string;
  operation_id: string; // routing_operations table ID
  operation_master_id?: string; // master operations table ID
  operation_name: string;
  operation_code: string;
  workstation_id?: string;
  workstation_name: string;
  process_time: number;
  setup_time: number;
  is_subcontracted: boolean;
  qc_required: boolean;
  sequence_no: number;
}

export function useComponentOperations() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const getComponentOperations = useCallback(async (componentId: string) => {
    if (!componentId) return [];
    
    setIsLoading(true);
    setError(null);

    try {
      console.log("Fetching operations for component ID:", componentId);
      
      const { data, error } = await supabase
        .from('routing_component_operations_with_details')
        .select(`
          id,
          routing_id,
          component_id,
          operation_id,
          operation_master_id,
          operation_name,
          operation_code,
          workstation_id,
          workstation_name,
          process_time,
          setup_time,
          is_subcontracted,
          qc_required,
          sequence_no
        `)
        .eq('component_id', componentId)
        .order('sequence_no', { ascending: true });

      if (error) {
        console.error("Error fetching component operations:", error);
        throw error;
      }
      
      console.log(`Successfully fetched ${data?.length || 0} operations for component`);
      
      return data as ComponentOperation[];
    } catch (err) {
      console.error('Error fetching component operations:', err);
      setError(err as Error);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    getComponentOperations,
    isLoading,
    error
  };
}
